// Section1.js
import React, { useState } from "react";
import { Grid, TextField, TextareaAutosize } from "@material-ui/core";
import Button from '@mui/material/Button';

import CardTitles from "./CardTitles";

const Section1 = ({ setName, setEmail, setPhone, setInstagram, setCarDetailsPopup, carDetails }) => {
  const [name, setNameState] = useState("");
  const [phoneNumber, setPhoneNumberState] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [EmailError, setEmailError] = useState(false);
  const [NameError, setNameError] = useState(false);
  const [email, setEmailState] = useState("");
  const [instagram, setInstagramState] = useState("");

  const handleName = async (e) => {
    await setNameState(e.target.value)
    if (e.target.value !== '') {
      await setName(e.target.value)
      setNameError(false);
    } else {
      await setName('')
      setNameError(true);
    }
  }
  const handlePhone = async (e) => {
    await setPhoneNumberState(e.target.value)
    const phone = e.target.value

    const test = /^(\+4|)?(07[0-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|\-)?([0-9]{3}(\s|\.|\-|)){2}$/igm

    if (test.test(phone)) {
      await setPhone(e.target.value)
      setPhoneError(false)
    }
    else {
      await setPhone('')
      setPhoneError(true)
    }
  }
  const handleEmail = async (e) => {
    await setEmailState(e.target.value)
    const email = e.target.value
    const test = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/

    if (test.test(email)) {
      await setEmail(e.target.value)
      setEmailError(false)
    }
    else {
      await setEmail('')
      setEmailError(true)
    }
  }
  const handleInstagram = async (e) => {
    await setInstagramState(e.target.value)
    await setInstagram(e.target.value)
  }

  return (
    <div className="section">
      <CardTitles title="Client Information" subtitle="It's awesome you're here. Now, please, introduce yourself." />
      <Grid container spacing={3} alignContent="center" alignItems="center" justifyContent="center">
        <Grid item xs={12} sm={6}>
          <TextField
            name="nume"
            label="Name"
            value={name}
            onChange={handleName}
            onKeyDown={handleName}
            required
            color="secondary"
            error={NameError}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="telefon"
            label="Phone Number"
            value={phoneNumber}
            onChange={handlePhone}
            onKeyDown={handlePhone}
            required
            color="secondary"
            type="phone"
            error={phoneError}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Email"
            name="email"
            value={email}
            onChange={handleEmail}
            onKeyDown={handleEmail}
            required
            color="secondary"
            type="email"
            error={EmailError}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Instagram Tag (optional)"
            name="instagram"
            value={instagram}
            onChange={handleInstagram}
            onKeyDown={handleInstagram}
            onKeyUp={handleInstagram}
            onBlur={handleInstagram}
            onFocus={handleInstagram}
            onKeyPress={handleInstagram}
            color="secondary"
          />
        </Grid>
      </Grid>
      <Grid>
        <Button onClick={e => setCarDetailsPopup(true)} type="submit" className="car-details-button" variant="contained" color={carDetails ? "success" : "secondary"}>{!carDetails ? "Add Car Details" : "Car details: " + carDetails}</Button>
      </Grid>
      <div className="subnotes">
        <small>We do not store any data. The email will only be used to send the files, or to communicate important details while the project is ongoing.</small>
      </div>
    </div>
  );
}

export default Section1;
